import React, { useMemo } from "react";

import {
  GetOffersExperienceListResponseType,
  PersonalizationOfferType,
} from "@intelligems/ig-types";
import { sortByStatus } from "@intelligems/ig-utils";
import { BaseExperienceTable } from "@src/components/Table/BaseExperienceTable";
import { useSearchOffersData } from "@src/features/sharedExperience/tableUtils";
import { UseQueryResult } from "@tanstack/react-query";

interface OffersTableProps {
  offerPersonalizationsData: UseQueryResult<
    GetOffersExperienceListResponseType,
    Error
  >;
  searchInput: string;
  statusFilters: string[];
  typeFilters: PersonalizationOfferType[];
}

export const OffersTable = ({
  offerPersonalizationsData,
  searchInput,
  statusFilters,
  typeFilters,
}: OffersTableProps) => {
  const sortedRowData = useMemo(() => {
    if (!offerPersonalizationsData.data?.experiencesList) return [];

    return sortByStatus([
      ...offerPersonalizationsData.data.experiencesList,
    ]).sort((a, b) => {
      if (!a || !b || !!a.archivedAtTs === !!b.archivedAtTs) {
        return 0;
      }
      return a.archivedAtTs ? 1 : -1;
    });
  }, [offerPersonalizationsData.data?.experiencesList]);

  const searchedRowData = useSearchOffersData(
    sortedRowData,
    searchInput,
    typeFilters,
    statusFilters,
    "offers"
  );
  return (
    <BaseExperienceTable
      renderLocation={"offers"}
      rowData={searchedRowData}
      isLoading={offerPersonalizationsData.isLoading}
    />
  );
};
